export interface ProgramRequestClassEnsamble{
    id: number;
    ensamble: string;
}

export const createProgramRequestClassEnsambleInitial = () : ProgramRequestClassEnsamble => {
    return {
        id: 0,
        ensamble: ""
    }
}